export interface GetBackofficeApiClientDetailKeysResponse {
  id_api_client_key: string;
  id_api_client: string;
  created_at: string;
  created_by: string;
}

export type ApiClient = {
  id_api_client: string;
  establishment_id: string;
  name: string;
  description: string;
  created_at: string;
  created_by: string;
  removed_at?: string;
  removed_by?: string;
};

export type GetBackofficeApiClientDetailResponse = {
  id_api_client: string;
  establishment_id: string;
  name: string;
  description: string;
  created_at: string;
  created_by: string;
  removed_at?: string;
  removed_by?: string;
  keys: GetBackofficeApiClientDetailKeysResponse[];
};

export interface GetApiClientKeyScopesResponse {
  id_api_client_key_scope: string;
  scope: string;
  created_at: string;
  created_by: string;
}

export type GetBackofficeApiClientKeyDetailResponse = {
  id_api_client_key: string;
  id_api_client: string;
  created_at: string;
  created_by: string;
  removed_at?: string;
  removed_by?: string;
  scopes: GetApiClientKeyScopesResponse[];
  modal?: boolean;
  scopesList?: string[];
};

export type GetBackofficeApiClientKeySecretResponse = {
  secret_key: string;
  modal?: boolean;
};

export type GetBackofficeApiClientKeySecret = {
  secret_key: string;
};

export type CreateApiClientKey = {
  scopes: string[];
};

export type CreateApiClientKeyParams = {
  param_id_api_client: string;
  scopes: string[];
};

export type CreateApiClientKeyScope = {
  scope: string;
};

export type CreateApiClientKeyScopeParams = {
  param_id_api_client_key: string;
  scope: string;
};

export enum EnumScopeType {
  BILL_CREATE_MANUALLY = 'bill.create.manually',
  BILL_SEARCH = 'bill.search',
  CARD_CREATE = 'card.create',
  CARD_READ = 'card.read',
  CHARGE_CHALLENGE = 'charge.challenge',
  CHARGE_OPTION_CREATE = 'charge.option.create',
  CHECKOUT_CONFIRM = 'checkout.confirm',
  CHECKOUT_CREATE = 'checkout.create',
  CHECKOUT_READ = 'checkout.read',
  CLIENT_CREATE = 'client.create',
  CLIENT_LIST = 'client.list',
  CLIENT_READ = 'client.read',
  CLIENT_UPDATE = 'client.update',
  COLLECTION_EXPORT = 'collection.export',
  DEBIT_BILL = 'debit.bill',
  INVOICE_READ = 'invoice.read',
  INVOICE_SEARCH = 'invoice.search',
  ORDER_3DS = 'order.3ds',
  ORDER_CANCEL = 'order.cancel',
  ORDER_CAPTURE = 'order.capture',
  ORDER_CREATE = 'order.create',
  ORDER_BILL_EXPORT = 'order.bill.export',
  ORDER_LIST = 'order.list',
  ORDER_READ = 'order.read',
  ORDER_REFUND = 'order.refund',
  PARTNER_LIST = 'partner.list',
  PARTNER_SEARCH = 'partner.search',
  PAYMENT_LINK_CANCEL = 'payment-link.cancel',
  PAYMENT_LINK_CREATE = 'payment-link.create',
  PAYMENT_LINK_READ = 'payment-link.read',
  PAYMENT_LINK_SEARCH = 'payment-link.search',
  PAYMENT_LINK_UPDATE = 'payment-link.update',
  PLAN_CREATE = 'plan.create',
  PLAN_DELETE = 'plan.delete',
  PLAN_READ = 'plan.read',
  PLAN_SEARCH = 'plan.search',
  PLAN_UPDATE = 'plan.update',
  PIX_SEARCH = 'pix.search',
  SIMULATION_CREATE = 'simulation.create',
  SUBSCRIPTION_CREATE = 'subscription.create',
  SUBSCRIPTION_DELETE = 'subscription.delete',
  SUBSCRIPTION_READ = 'subscription.read',
  SUBSCRIPTION_SEARCH = 'subscription.search',
  SUBSCRIPTION_UPDATE = 'subscription.update',
  WEBHOOK_CANCEL = 'webhook.cancel',
  WEBHOOK_CREATE = 'webhook.create',
  WEBHOOK_SEARCH = 'webhook.search',
  WEBHOOK_EVENT_RETRY = 'webhook.event.retry',
  WEBHOOK_EVENT_SEARCH = 'webhook.event.search',
}

export const scopeTypeLabels = {
  'bill.create.manually': 'bill.create.manually',
  'bill.search': 'bill.search',
  'card.create': 'card.create',
  'card.read': 'card.read',
  'charge.challenge': 'charge.challenge',
  'charge.option.create': 'charge.option.create',
  'checkout.confirm': 'checkout.confirm',
  'checkout.create': 'checkout.create',
  'checkout.read': 'checkout.read',
  'client.create': 'client.create',
  'client.list': 'client.list',
  'client.read': 'client.read',
  'client.update': 'client.update',
  'collection.export': 'collection.export',
  'debit.bill': 'debit.bill',
  'invoice.read': 'invoice.read',
  'invoice.search': 'invoice.search',
  'order.3ds': 'order.3ds',
  'order.cancel': 'order.cancel',
  'order.capture': 'order.capture',
  'order.create': 'order.create',
  'order.bill.export': 'order.bill.export',
  'order.list': 'order.list',
  'order.read': 'order.read',
  'order.refund': 'order.refund',
  'partner.list': 'partner.list',
  'partner.search': 'partner.search',
  'payment-link.cancel': 'payment-link.cancel',
  'payment-link.create': 'payment-link.create',
  'payment-link.read': 'payment-link.read',
  'payment-link.search': 'payment-link.search',
  'payment-link.update': 'payment-link.update',
  'plan.create': 'plan.create',
  'plan.delete': 'plan.delete',
  'plan.read': 'plan.read',
  'plan.search': 'plan.search',
  'plan.update': 'plan.update',
  'pix.search': 'pix.search',
  'simulation.create': 'simulation.create',
  'subscription.create': 'subscription.create',
  'subscription.delete': 'subscription.delete',
  'subscription.read': 'subscription.read',
  'subscription.search': 'subscription.search',
  'subscription.update': 'subscription.update',
  'webhook.cancel': 'webhook.cancel',
  'webhook.create': 'webhook.create',
  'webhook.search': 'webhook.search',
  'webhook.event.retry': 'webhook.event.retry',
  'webhook.event.search': 'webhook.event.search',
};
